module.exports = __webpack_public_path__ + "static/logo_white-c17c4a4127eb4b2d3396f88661197342.png";